module.exports = __webpack_public_path__ + "img/2pica.33c964ae.png";